import { SVGProps, Ref, forwardRef } from 'react';

export const GESize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <rect y={2} width={16} height={12} rx={2} fill="#EEEEEE" />
            <path d="M6.75 9.25V14h2.5V9.25H16v-2.5H9.25V2h-2.5v4.75H0v2.5z" fill="#E8112D" />
            <path
                d="M3.829 11.829q.022.463.11.921a3.6 3.6 0 0 0-.877 0q.087-.458.11-.921a7 7 0 0 0-.922.11 3.6 3.6 0 0 0 0-.877q.458.086.921.11a7 7 0 0 0-.11-.922q.44.054.877 0a7 7 0 0 0-.11.921q.465-.022.922-.11a3.6 3.6 0 0 0 0 .877 7 7 0 0 0-.921-.11"
                fill="#E8112D"
            />
            <path
                d="M12.938 12.75a7 7 0 0 1-.11-.921q.465.021.922.11a3.6 3.6 0 0 1 0-.877 7 7 0 0 1-.921.11q.022-.465.11-.922-.438.054-.877 0 .086.458.11.921a7 7 0 0 1-.922-.11q.054.438 0 .877.458-.086.921-.11a7 7 0 0 1-.11.922q.438-.054.877 0"
                fill="#E8112D"
            />
            <path
                d="M3.829 4.829q.022.463.11.921a3.6 3.6 0 0 0-.877 0q.087-.458.11-.921a7 7 0 0 0-.922.11 3.6 3.6 0 0 0 0-.877q.458.087.921.11a7 7 0 0 0-.11-.922q.44.054.877 0a7 7 0 0 0-.11.921q.465-.022.922-.11a3.6 3.6 0 0 0 0 .877 7 7 0 0 0-.921-.11"
                fill="#E8112D"
            />
            <path
                d="M12.938 5.75a7 7 0 0 1-.11-.921q.465.021.922.11a3.6 3.6 0 0 1 0-.877 7 7 0 0 1-.921.11q.022-.465.11-.922-.438.054-.877 0 .086.458.11.921a7 7 0 0 1-.922-.11q.054.439 0 .877.458-.087.921-.11a7 7 0 0 1-.11.922q.438-.054.877 0"
                fill="#E8112D"
            />
        </g>
    </svg>
));
GESize16Glyph.displayName = 'GESize16Glyph';
